// extracted by mini-css-extract-plugin
module.exports = {"customCheckBox":"CustomCheckbox_customCheckBox__2ZuEf","dark":"CustomCheckbox_dark__2PRDV","disabled":"CustomCheckbox_disabled__dMOKD"};